import img1 from '../assets/img1.png'
import img2 from '../assets/img2.png'
import img3 from '../assets/img3.png'
import img4 from '../assets/img4.png'
import img5 from '../assets/img5.png'
import img6 from '../assets/img6.jpg'
import img7 from '../assets/img7.jpg'
import img8 from '../assets/img8.jpg'
import img9 from '../assets/img9.png'
export const Contents = [
    {
        heading:"What is a Crypto Wallet?",
        text:"A cryptocurrency wallet is a device, program service, or physical medium that stores the public and/or private keys for cryptocurrency transactions.",
        image:img3,
        height: 350
    },
    {
        heading:"Why is it Important?",
        text:"Crytocurrency wallets mainly provide the basic function of storing keys, but may also offer encryption and signing functuality. These wallets are used to send and recieve cryptocurrencies, interact with decentralized apps, and execute smart contracts.",
        image:img4,
        height: 350
    },
    {
        heading: "Cold vs hard wallet:",
        text: "A cold wallet and a hard wallet are terms that are interchanegeably to refer to a type of wallet that is designed to store cryptocurrency or other digital assets offline, away from the internet.The main difference is that a hard wallet is a specific type of cold wallet that is usually in the form of a physical device that is plugged into a computer or other device when you need to use it.This device generates private keys that never leave the device, which provides an extra layer of security.",
        image: img1 ,
        height: 250
    },
    {
        heading: "Problem Today:",
        text: "Most cryptocurrency exchanges offer inadequate security measures, requiring users to store valueablecoins on their platform. in the event of a breach, people are at significant risk.",
        image: img9,
        height: 300
    },
    {
        heading: "HHCW's Solution:",
        text: "A timepiece that doubles as a sophisticated cryptocurrency wallet.With the HHCW 1.0, the user will have access to his or her wallet which will come with its own private keys and 2fA to ensure security. We have even took it up a notch and added a 3rd layer of security which is biometrics.People will now have the ability to access their wallet from anywhere without the use of a computer, people can now safely moniter their wallet to ensure detection of fraud and transactions with the use of notifications.Lastly, this stylish time piece is crafted with a unique modern style by the worlds finest watch makers, blockchain experts and engineers.",
        image: img2,
        height: 350
    },{
        heading: "",
        text: "",
        image: img8, //img8,
        height: 350
    },
    {
        heading: "How to purchase the HHCW?",
        text: "You can purchase the HHCW when the launch is live, on exchanges (will be announced soon), and also distribution via airdrops! ",
        image: img8, //img8,
        height: 350
    },
    {
        heading: "Why on Polygon blockchain?",
        text: "We use polygon because the Polygon Network has faster and cheaper transactions, Compatibility with the Ethereum blockchain network which supports smart contracts. Polygon also uses consensus mechanism (proof of stake), which provides a high level of security. In order to purchase the HHCW Token you will need Matic which is the native currency of the Polygon network.",
        image: "https://cryptologos.cc/logos/polygon-matic-logo.png" ,
        height: 300
    },
    //img9
    {
        heading: "Founder info:",
        text: "Gabriel Covington, Founder of HHCW is a web3 cryptography enthusiast with an extensive background in Non Profit Organizations, marketing and technology. Gabriel, has worked with dozens of web3 companies including projects backed by Silicone Valley, Stanford, Yale and more. The NFT enthusiast, started his own company after creating the cryptocurrency blog:www.hiphopcryptowatch.com. Gabriel has always innovated many ways and use cases for blockchain technology in the ever growing field of cryptocurrency, web3, blogging and much more.",
        image: img5,
        height: 350
    },
    {
        heading: "",
        text: "The company HHCW aims to accomplish a series of goals and objectives while having fun along the way. The main objective overall is to spread knowledge to the population about decentralization, and the education of cryptocurrency. The company started this mission by creating our cryptocurrency blog:www.hiphopcryptowatch.com, currently we are launching our first product the HHCW 1.0. in the near future stay tuned for upcoming announcements and events from the company you dont want to miss!",
        image: img6,
        height: 300
    },
    //img7
]